import { NgxPrintModule } from 'ngx-print';
import { EffectsModule } from '@ngrx/effects';
import { SharedModule } from './../../../shared/src/lib/shared.module';
import { SpinnersModule } from './../../../spinners/src/lib/spinners.module';
import { EpimsDashboardNavModule } from './../../../epims-dashboard-nav/src/lib/epims-dashboard-nav.module';
import { AngularMaterialModule } from './../../../material/src/lib/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { ScholarshipRoutingModule } from './scholarship-routing.module';
import { ScholarshipManagementContainerComponent } from './containers/scholarship-management-container/scholarship-management-container.component';

import * as fromScholarship from './states/+scholarship-management';
import { ScholarshipManagementFacade } from './states/+scholarship-management/scholarship-management.facade';
import { ScholarshipManagementEffects } from './states/+scholarship-management/scholarship-management.effects';
import { ScholarshipManagementComponent } from './components/scholarship-management/scholarship-management.component';
import { CreateScholarshipManagementComponent } from './components/create-scholarship-management/create-scholarship-management.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ScholarshipManagementListComponent } from './components/scholarship-management-list/scholarship-management-list.component';
import { ScholarshipInfoService } from './services/scholarshipinfo.service';
import { ViewScholarshipManagementComponent } from './components/view-scholarship-management/view-scholarship-management.component';
import { ScholarshipPaymentEffects } from './states/+scholarship-payment/scholarship-payment.effects';
import { ScholarshipPaymentFacade } from './states/+scholarship-payment/scholarship-payment.facade';
import { ScholarshipPaymentReportComponent } from './components/scholarship-payment-report/scholarship-payment-report.component';

export const scholarshipManagementRoutes: Route[] = [];

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		AngularMaterialModule,
		NgxMatSelectSearchModule,
		EpimsDashboardNavModule,
		ScholarshipRoutingModule,
		HttpClientModule,
		SpinnersModule,
    SharedModule,
    NgxPrintModule,
		ReactiveFormsModule,
		StoreModule.forFeature(
			fromScholarship.ScholarshipManagementStoreReducer.SCHOLARSHIP_MANAGEMENT_FEATURE_KEY,
			fromScholarship.ScholarshipManagementStoreReducer.reducer
		),
		EffectsModule.forFeature([ ScholarshipManagementEffects, ScholarshipPaymentEffects ])
	],
	declarations: [
		ScholarshipManagementContainerComponent,
		ScholarshipManagementComponent,
		CreateScholarshipManagementComponent,
		ScholarshipManagementListComponent,
		ViewScholarshipManagementComponent,
		ScholarshipPaymentReportComponent
	],
	providers: [ ScholarshipManagementFacade, ScholarshipInfoService, ScholarshipPaymentFacade ]
})
export class ScholarshipManagementModule {}
